import { render, staticRenderFns } from "./NexelStatus.vue?vue&type=template&id=48d6a13a&scoped=true"
import script from "./NexelStatus.vue?vue&type=script&lang=js"
export * from "./NexelStatus.vue?vue&type=script&lang=js"
import style0 from "./NexelStatus.vue?vue&type=style&index=0&id=48d6a13a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d6a13a",
  null
  
)

export default component.exports